/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S5_Li1_PreInputs */

const tr_iade_iptal_s5_li1_pre = /** @type {(inputs: Iade_Iptal_S5_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İade talebi, ödeme tarihi ile sipariş veya fatura bilgisi belirtilerek`)
};

const en_iade_iptal_s5_li1_pre = /** @type {(inputs: Iade_Iptal_S5_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The refund request must be sent to`)
};

const de_iade_iptal_s5_li1_pre = /** @type {(inputs: Iade_Iptal_S5_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Erstattungsantrag ist unter Angabe des Zahlungsdatums sowie der Bestell- oder Rechnungsangaben an`)
};

const ru_iade_iptal_s5_li1_pre = /** @type {(inputs: Iade_Iptal_S5_Li1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заявление о возврате направляется на`)
};

/**
* | output |
* | --- |
* | "The refund request must be sent to" |
*
* @param {Iade_Iptal_S5_Li1_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s5_li1_pre = /** @type {((inputs?: Iade_Iptal_S5_Li1_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S5_Li1_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s5_li1_pre(inputs)
	if (locale === "de") return de_iade_iptal_s5_li1_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s5_li1_pre(inputs)
	return tr_iade_iptal_s5_li1_pre(inputs)
});